import { render, staticRenderFns } from "./uploadWork.vue?vue&type=template&id=2fde6884"
import script from "./uploadWork.vue?vue&type=script&lang=js"
export * from "./uploadWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports